import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PrintBatchData } from '@app/services/batches/print-batches';
import { FreightServiceType } from '@pdqdev/pdq-shared/dist/CarrierData';

@Component({
  selector: 'app-generating-label-item',
  templateUrl: './generating-label-item.component.html',
  styleUrls: ['./generating-label-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GeneratingLabelItemComponent implements OnInit {
  @Input() batch: PrintBatchData;
  isTplCarrier;

  ngOnInit(): void {
    this.isTplCarrier = this.batch.selectedCarrier?.freightServiceType?.includes(
      FreightServiceType.FULFILLMENT_SERVICE_3PL,
    );
  }

  getGeneratingLabelsText(): string {
    if (this.batch.succeeded <= Math.floor(this.batch.total / 2)) {
      return 'Preparing Labels';
    }

    if (this.batch.succeeded > Math.floor(this.batch.total) / 2) {
      return 'Almost Done';
    }

    return 'Finalizing Labels';
  }
}
